import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './content-box.scss';

const ContentBox = ({ children, flowType }) => {
    const boxStyle = (flowType === 'column') ? `${css['content-box']} ${css['column-flow']}` :
        `${css['content-box']} ${css['row-flow']}`;
    return (
        <div className={boxStyle}>
            {children}
        </div>
    );
};

/**
 * Define the type of properties that can be set on this component
 */
ContentBox.propTypes = {
    children: PropTypes.any,
    flowType: PropTypes.string
};

export default styleable(css)(ContentBox);



// WEBPACK FOOTER //
// ./components/content-box/content-box.js